import { defaultShelfTagSize } from './shelfTags.mjs';

// Keep URL values as strings so PDF validation can reject malformed values.
export function readShelfTagRequest(search) {
  const query = new URLSearchParams(search);
  return {
    sizeId: query.get('size') ?? defaultShelfTagSize,
    price: query.get('price') ?? '',
    copies: query.get('copies') ?? '1',
  };
}

export function shelfTagProduct(data, itemNumber) {
  const item = Array.isArray(data) ? data[0] : data;
  // The spec-sheet aggregate query can return an all-null row for a missing item.
  if (!item?.itemno || String(item.itemno) !== String(itemNumber)) return null;
  return {
    itemNumber: String(item.itemno),
    name: item.description || `Item ${item.itemno}`,
    upc: item.upc,
  };
}
